import type { SVGProps } from 'react';

export function CodeLaptop({ className = '', ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 400"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={className}
      aria-hidden="true"
      {...props}
    >
      {/* laptop base */}
      <path d="M40 290 h320 l-20 40 h-280 z" />
      {/* laptop lid */}
      <rect x="70" y="90" width="260" height="200" rx="4" />
      {/* terminal content */}
      <rect x="90" y="110" width="220" height="160" fill="#15150F" stroke="currentColor" />
      {/* prompt lines */}
      <g strokeWidth="2" stroke="#E7FF4D">
        <line x1="100" y1="130" x2="120" y2="130" />
      </g>
      <line x1="125" y1="130" x2="230" y2="130" />
      <g strokeWidth="2" stroke="#E7FF4D">
        <line x1="100" y1="150" x2="120" y2="150" />
      </g>
      <line x1="125" y1="150" x2="260" y2="150" />
      <line x1="125" y1="170" x2="200" y2="170" />
      <line x1="100" y1="190" x2="180" y2="190" />
      <line x1="100" y1="210" x2="250" y2="210" />
      <g strokeWidth="2" stroke="#E7FF4D">
        <line x1="100" y1="230" x2="120" y2="230" />
      </g>
      <line x1="125" y1="230" x2="220" y2="230" />
      <rect x="100" y="245" width="8" height="14" fill="#E7FF4D" stroke="none" />
    </svg>
  );
}
